type ErrorObject = {
  [key: string]: any;
};

export default function getReactHookFormErrorsRefNames(obj: ErrorObject): string[] {
  const refNames: string[] = [];

  function traverse(current: any) {
    if (typeof current !== 'object' || current === null) return;

    if (current.ref?.name) {
      refNames.push(current.ref.name);
    }

    for (const key in current) {
      if (current.hasOwnProperty(key)) {
        traverse(current[key]);
      }
    }
  }

  traverse(obj);
  return refNames;
}
